import { useTranslation } from 'react-i18next';

export default () => {
 
    const [t] = useTranslation();

    return {
        required: t('field_required').toString(),
    }
  
}